"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@stitches/react");
var react_2 = require("react");
var stitches_config_1 = require("../stitches.config");
var StyledButtonGroup = (0, react_1.styled)("div", (_a = {
        display: "inline-flex"
    },
    _a["&  :first-child"] = {
        borderRadius: "".concat(stitches_config_1.theme.shape.borderRadius, " 0px 0px ").concat(stitches_config_1.theme.shape.borderRadius),
    },
    _a["&  :not(:first-child):not(:last-child)"] = {
        borderRadius: "0px",
    },
    _a["&  :last-child"] = {
        borderRadius: "0px ".concat(stitches_config_1.theme.shape.borderRadius, " ").concat(stitches_config_1.theme.shape.borderRadius, " 0px"),
    },
    _a));
exports.ButtonGroup = (0, react_2.forwardRef)(function (props, ref) {
    return ((0, jsx_runtime_1.jsx)(StyledButtonGroup, __assign({}, props, { ref: ref }, { children: props.children })));
});
//# sourceMappingURL=ButtonGroup.js.map